import actionTypes from 'constants/actionTypes'

interface DragState {
  isDragging: boolean
  id: string | null
}

interface DragAction {
  type: string
  payload?: {
    id?: string | null
  }
}

const initialState: DragState = {
  isDragging: false,
  id: null,
}

const drag = (state: DragState = initialState, action: DragAction): DragState => {
  switch (action.type) {
    case actionTypes.GRAPH.DRAG.START:
      return {
        isDragging: true,
        id: action.payload?.id ?? null
      }
    case actionTypes.GRAPH.DRAG.STOP:
      return {
        isDragging: false,
        id: null
      }
    default:
      return state
  }
}

export default drag
